<template>
  <div>
    <v-layout wrap pt-5 pt-sm-0 pt-md-0>
      <v-flex xs12 align-self-center>
        <v-tabs
          v-model="tabValue"
          hide-slider
          background-color="#F8F8F8"
          centered
          center-active
          :show-arrows="true"
          light
          active-class="activ"
          class="nonactiv"
        >
          <v-tab v-for="(item, i) in stages" :key="i">
            <span class="text-none" style="font-family: poppinssemibold">
              {{ item.name }}
            </span>
          </v-tab>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-layout wrap pb-6 justify-center v-if="seller">
      <v-flex xs12 v-if="seller">
        <Level1
          v-if="tabValue == '0'"
          :storage="seller"
          @stepper="winStepper"
        />
        <Level2
          v-if="tabValue == '1'"
          :storage="seller"
          @stepper="winStepper"
        />
        <Level3
          v-if="tabValue == '2'"
          :storage="seller"
          @stepper="winStepper"
        />
        <Level4
          v-if="tabValue == '3'"
          :storage="seller"
          @stepper="winStepper"
        />
        <Level5
          v-if="tabValue == '5'"
          :storage="seller"
          @stepper="winStepper"
        />
        <Level6
          v-if="tabValue == '4'"
          :storage="seller"
          @stepper="winStepper"
        />
        <Level7
          v-if="tabValue == '6' && flag"
          :storage="seller"
          @stepper="winStepper"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Level1 from "./level1";
import Level2 from "./level2";
import Level3 from "./level3";
import Level4 from "./level4";
import Level5 from "./level7";
import Level6 from "./leVel6";
import Level7 from "./level7";

// import Level7 from "./level4";

export default {
  components: {
    Level1,
    Level2,
    Level3,
    Level4,
    Level5,
    Level6,
    Level7,
  },
  data() {
    return {
      level: 0,
      flag: true,
      tabValue: 0,
      stages: [
        { name: "Primary Details" },
        { name: "Services & Working Hours" },
        { name: "Bank Details" },
        { name: "Documents" },
        { name: "Reviews" },
        { name: "Shop Images" },
      ],
      seller: null,
    };
  },
  // computed: {
  //   applevel() {
  //     return this.getProfile();
  //   },
  // },

  beforeMount() {
    // this.getLevl();
    this.getProfile();
  },
  methods: {
    winStepper(window_data) {
      this.flag=false
      this.level = window_data.level;
      console.log("stepper initialized", this.level);
      if (window_data.tabval) {

        console.log("op",window_data)
        this.getProfile();
        this.flag=true

      }
    },
    winStepper1(window_data) {
      if (window_data) console.log("got it");
      this.tabValue = window_data.tabval;
      this.getProfile();
      console.log("stepper working", this.tabValue);
    },

    // getLevl() {
    //   this.level = this.$store.state.level;
    //   console.log("level", this.level);
    // },
    getProfile() {
      this.seller=null
      axios({
        method: "post",
        url: "user/me",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.seller = response.data.data.sellerid;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.activ {
  color: black !important;
  font-family: poppinssemibold !important;
  border-bottom: 2.5px solid #3460e1;
}
.nonactiv {
  color: #acacac !important;
  font-family: poppinsthin !important;
}
</style>
